import echo from '../../plugins/echo';
import {find, findIndex, isArray, isInteger, isObject, isString, orderBy} from 'lodash';
import dataService from '../../../../ml/services/dataService';
import productService from '../../services/productService';
import axios from '../../services/axiosService';
import disclaimerService from '../../services/disclaimerService';
import fetchService from '../../services/fetchService';
import emailVerificationService from '../../services/emailVerificationService';
import vueStateService from '../../services/vueStateService';
import shareTemplateService from '../../../../ml/services/shareTemplateService';

let refreshID = null; // MLD-4934

const homeFolder = {
  id: -1,
  name: 'Home',
  is_home: true,
  is_bookmarks: false,
  is_private: false,
  children: [],
  icon: 'fa-home',
};

const designations = [
  //{id: '', name: ''},
  {id: 'MD', name: 'MD'},
  {id: 'DO', name: 'DO'},
  {id: 'NP', name: 'NP'},
  {id: 'PA', name: 'PA'},
  {id: 'PhD', name: 'PhD'},
];

const salutations = [ // MLD-3985
  {id: 'Dr.', name: 'Dr.'},
  {id: 'Mr.', name: 'Mr.'},
  {id: 'Ms.', name: 'Ms.'},
  {id: 'Mrs.', name: 'Mrs.'},
  {id: 'Prof.', name: 'Prof.'},
];

const state = {
  agent: window.config ? window.config.agent : null, // MLD-3019
  activeFolders: [homeFolder.id],
  config: window.config ? window.config : null, // MLD-5627
  countries: dataService.getCountries(),
  disclaimers: [], // MLD-5970
  env: window.config ? window.config.env : null, // MLD-2752
  errorMessage: null,
  folder: null,
  folders: [],
  folderTree: [],
  loadingGroups: false,
  groups: [],
  homeFolder: homeFolder,
  labels: [],
  links: [],
  locales: [],
  presentationJobs: [], // MLD-2156
  loadingPresentations: false,
  presentations: [],
  products: [], // MLD-4360
  reloadRequired: false, // MLD-4934
  loadingShareTemplates: false, // MLD-5194
  shareTemplates: [],
  shareThemes: [],
  spaces: [], // MLD-5627
  states: dataService.getStates(), // MLD-2872
  successMessage: null,
  teamRoles: dataService.teamRoles(),
  timezones: window.config ? window.config.timezones : [],
  loadingUsers: false, // MLD-4860
  users: [],
  emailCreditInfo: { // MLD-6180
    enabled: false,
    total_credits: 0,
    available_credits: 0,
    loaded: false,
  },
}

const mutations = {
  setActiveFolders(state, activeFolders) {
    state.activeFolders = activeFolders;
  },
  setCountries(state, countries) {
    state.countries = countries;
  },
  setDisclaimers(state, disclaimers) { // MLD-5970
    state.disclaimers = orderBy(disclaimers, ['slug'], ['asc']);
  },
  setErrorMessage(state, errorMessage) {
    state.errorMessage = errorMessage;
  },
  setFolder(state, folder) {
    if (isObject(folder) && folder.id) {
      state.folder = folder;
      state.activeFolders = [folder.id];
    } else {
      state.folder = homeFolder;
      state.activeFolders = [homeFolder.id];
    }
  },
  setFolders(state, folders) {
    state.folders = folders;
  },
  setFolderTree(state, folderTree) {
    state.folderTree = folderTree;
  },
  setGroup(state, group) { // MLD-5194
    if (isObject(group)) {
      const index = findIndex(state.groups, g => g.id === group.id);
      if (index === -1) {
        state.groups.push(group);
      } else {
        state.groups[index] = group;
      }
      state.groups = orderBy(state.groups, ['slug'], ['asc']);
    }
  },
  setGroups(state, groups) {
    state.groups = orderBy(groups, ['slug'], ['asc']);
  },
  setLabels(state, labels) {
    state.labels = orderBy(labels, ['name'], ['asc']);
  },
  setLinks(state, links) {
    state.links = links;
  },
  setLocales(state, locales) {
    state.locales = orderBy(locales, ['name'], ['asc']);
  },
  setLoadingGroups(state, loading) {
    state.loadingGroups = loading;
    console.log('loadingGroups: ', loading);
  },
  setLoadingPresentations(state, loading) {
    state.loadingPresentations = loading;
    console.log('loadingPresentations: ', loading);
  },
  setLoadingShareTemplates(state, loading) {
    state.loadingShareTemplates = loading;
    console.log('loadingShareTemplates: ', loading);
  },
  setLoadingUsers(state, loading) { // mLD_4860
    state.loadingUsers = loading;
    console.log('loadingUsers: ', loading);
  },
  setPresentationJobs(state, presentationJobs) {
    state.presentationJobs = presentationJobs;
  },
  setPresentation(state, presentation) {
    if (isObject(presentation)) {
      const index = findIndex(state.presentations, p => p.id === presentation.id);
      if (index === -1) {
        state.presentations.push(presentation);
      } else {
        state.presentations[index] = presentation;
      }
      state.presentations = orderBy(state.presentations, ['slug'], ['asc']);
    }
  },
  setPresentations(state, presentations) {
    state.presentations = orderBy(presentations, ['slug'], ['asc']);
  },
  setProducts(state, products) { // MLD-43560
    state.products = orderBy(products, ['slug'], ['asc']);
  },
  setReloadRequired(state, reloadRequired) { // MLD-4934
    state.reloadRequired = reloadRequired;
  },
  setShareTemplate(state, template) {
    if (isObject(template)) {
      const index = findIndex(state.shareTemplates, t => t.id === template.id);
      if (index === -1) {
        state.shareTemplates.push(template);
      } else {
        state.shareTemplates[index] = template;
      }
      state.shareTemplates = orderBy(state.shareTemplates, ['name'], ['asc']);
    }
  },
  setShareTemplates(state, shareTemplates) {
    state.shareTemplates = orderBy(shareTemplates, ['name'], ['asc']);
  },
  setShareThemes(state, shareThemes) {
    state.shareThemes = orderBy(shareThemes, ['name'], ['asc']);
  },
  setSpaces(state, spaces) { // MLD-5627
    state.spaces = spaces;
  },
  setSuccessMessage(state, successMessage) {
    state.successMessage = successMessage;
  },
  setTimezones(state, timezones) {
    state.timezones = timezones;
  },
  setUsers(state, users) {
    state.users = orderBy(users, ['slug'], ['asc']);
  },
  setEmailCreditInfo(state, emailCreditInfo) { // MLD-6180
    state.emailCreditInfo = emailCreditInfo;
  }
}

const getters = { // MLD-7618
  crmMailboxLabel(state, getters) {
    if (getters.team?.uses_salesforce) {
      return 'My "Email to Salesforce" Email Address';
    } else if (getters.team?.crm_provider_name) {
      return `${getters.team?.crm_provider_name} BCC Email Address'`
    }
    return null;
  },
  config: state => state.config,
  appURL(state, getters) { // MLD-5627
    if (isObject(getters.config)) {
      return getters.config.appURL;
    }
    return null;
  },
  pdfURL(state, getters) { // MLD-5627
    if (isObject(getters.config)) {
      return getters.config.pdfURL;
    }
    return null;
  },
  agent: state => state.agent, // MLD-3019
  // MLD-2752
  env: state => state.env,
  isLocal: state => state.env === 'local',
  isStaging: state => state.env === 'staging',
  isProduction: state => state.env === 'production',
  activeFolders: state => state.activeFolders,
  activePresentations: state => state.presentations.filter(p => p.is_active),
  activeUsers: state => state.users.filter(u => u.is_active),
  activeAdministrators(state, getters) { // MLD-5518
    return getters.activeUsers.filter(u => u.current_team_id === getters.team.id && u.team?.is_admin);
  },
  countries: state => state.countries,
  disclaimers: state => state.disclaimers,
  emailCreditInfo: state => state.emailCreditInfo, // MLD-6180
  errorMessage: state => state.errorMessage,
  folder: state => state.folder,
  folders: state => state.folders,
  folderTree: state => state.folderTree,
  groups: state => state.groups,
  homeFolder: state => state.homeFolder,
  labels: state => state.labels,
  links: state => state.links,
  isLoading: state => (state.loadingGroups || state.loadingPresentations || state.loadingShareTemplates || state.loadingUsers),
  loadingGroups: state => state.loadingGroups, // MLD-5194
  loadingPresentations: state => state.loadingPresentations,
  loadingShareTemplates: state => state.loadingShareTemplates,
  loadingUsers: state => state.loadingUsers, // MLD-4860
  locales: state => state.locales,
  openAllFolders: state => { // MLD-2757
    return !!state.activeFolders.length && state.activeFolders[0] !== state.homeFolder.id;
  },
  presentationJobs: state => state.presentationJobs,
  presentations: state => state.presentations,
  products: state => state.products, // MLD-4360
  reloadRequired: state => state.reloadRequired, // MLD-4934
  rootFolders(state) {
    const folders = [state.homeFolder];
    state.folders.filter(f => f.is_root).forEach(f => {
      folders.push(f);
    })
    return folders;
  },
  designations() { // MLD-3985
    return designations;
  },
  salutations() { // MLD-3985
    return salutations
  },
  shareTemplates: state => state.shareTemplates,
  quickShareTemplates: state => state.shareTemplates.filter(t => t.is_quick_share), // MLD-3997
  shareThemes: state => state.shareThemes,
  spaces: state => state.spaces, // MLD-5627
  states: state => state.states, // MLD-2872
  successMessage: state => state.successMessage,
  teamRoles: state => state.teamRoles,
  temporaryToken(state) {
    return window.config ? window.config.temporary_token : null; // MLD-2752
  },
  timezones: state => state.timezones,
  users: state => state.users,
}

const actions = {
  async clearSavedState({commit}) { // MLD-6444
    vueStateService.clearSavedState();
  },
  async fetchDisclaimers({commit}) {
    const data = await disclaimerService.getDisclaimers();
    commit('setDisclaimers', data);
  },
  async fetchEmailCreditInfo({commit}) { // MLD-6180
    try {
      const data = await emailVerificationService.getInfo();
      commit('setEmailCreditInfo', data);
    } catch (e) {
    }
  },
  async fetchFolders({commit}) {
    const {data} = await axios.get(`/api/team/folders`);
    commit('setFolders', data);
  },
  async fetchFolderTree({commit}) {
    const {data} = await axios.get(`/api/folders/flat-tree`);
    commit('setFolderTree', data);
  },
  async fetchGroup({commit}, groupID) {
    const {data} = await axios.get(`/api/groups/${groupID}`);
    commit('setGroup', data);
  },
  async fetchGroups({commit}) {
    commit('setLoadingGroups', true);
    const {data} = await axios.get(`/api/groups`);
    commit('setGroups', data);
    commit('setLoadingGroups', false);
  },
  async fetchLabels({commit}) {
    const {data} = await axios.get(`/api/labels`);
    commit('setLabels', data);
  },
  async fetchLocales({commit}) {
    const {data} = await axios.get(`/api/locales`);
    commit('setLocales', data);
  },
  async fetchPresentationJobs({commit, getters}) {
    const {data} = await axios.get(`/api/presentation-jobs`);
    commit('setPresentationJobs', data);
  },
  async fetchPresentation({commit}, presentationID) {
    const {data} = await axios.get(`/api/presentations/${presentationID}`)
    commit('setPresentation', data);
  },
  async fetchPresentations({commit}) {
    // MLD-4860 I implemented pagination.
    const chunkSize = 300;
    const concurrentRequests = 4;
    const url = `/api/presentations`
    let presentations = [];
    try {
      commit('setLoadingPresentations', true);
      presentations = await fetchService.fetchRecords(url, {}, chunkSize, concurrentRequests);
      commit('setPresentations', presentations);
    } catch (e) {
      console.log('fetchPresentations exception:', e.message);
      commit('setPresentations', presentations);
    } finally {
      commit('setLoadingPresentations', false)
    }
    return Promise.resolve(presentations);

    /*const {data} = await axios.get(`/api/presentations`);
    commit('setPresentations', data);*/
  },
  async fetchProducts({commit}) { // MLD-4360
    return productService.getProducts()
      .then(data => {
        commit('setProducts', data);
      })
      .catch(() => {
      })
  },
  async fetchShareTemplate({commit}, templateID) {
    const {data: template} = await axios.get(`/api/share-templates/${templateID}`);
    commit('setShareTemplate', template);
  },
  async fetchShareTemplates({commit}) {
    commit('setLoadingShareTemplates', true);
    const data = await shareTemplateService.getAllTemplates(); // MLD-6865 Get all templates
    commit('setShareTemplates', data);
    commit('setLoadingShareTemplates', false);
  },
  async fetchShareThemes({commit}) {
    const {data} = await axios.get(`/api/share-themes`);
    commit('setShareThemes', data);
  },
  async fetchSpaces({commit, getters}) {
    if (getters.canTeamUseSpaces) {
      const {data} = await axios.get(`/api/spaces`);
      commit('setSpaces', orderBy(data, ['slug'], ['asc']));
    }
  },
  async fetchUsers({commit}) {
    //console.time('fetchUsers');
    // MLD-4860 I refactored this to use pagination.
    const url = `/api/users`;
    const chunkSize = 100;
    const concurrentRequests = 4;
    const users = [];
    try {
      commit('setLoadingUsers', true);
      const users = await fetchService.fetchRecords(url, {}, chunkSize, concurrentRequests)
      commit('setUsers', users);
    } catch (e) {
      console.log('fetchUsers() exception:', e.message);
      commit('setUsers', users);
    } finally {
      commit('setLoadingUsers', false);
    }
    //console.timeEnd('fetchUsers');
    return Promise.resolve(users);
  },
  async initEcho({commit, dispatch, getters}, user) {
    if (!isObject(user)) {
      return;
    }
    if (!isString(user.channel)) {
      return;
    }
    console.log('initEcho for', user.name);
    echo.private(user.channel)
      .listen('Models.Presentation.Processing', e => {
        console.log('Processing', e);
        dispatch('content/fetchPresentations');
      })
      .listen('Models.Presentation.ProcessedForUser', e => {
        console.log('ProcessedForUser', e);
        commit('setSuccessMessage', e.message);
        dispatch('content/fetchUserData'); // MLD-3342
        /*dispatch('content/fetchBookmarks');
        dispatch('content/fetchFolders');
        dispatch('content/fetchPresentations');*/
      })
    const team = getters.team;
    if (team) {
      echo.private(team.channel)
        .listen('Models.Presentation.Deleted', e => {
          console.log('Models.Presentation.Deleted', e);
          dispatch('fetchPresentationJobs')
            .catch(() => {
            });
        })
        .listen('Models.Presentation.Processed', e => {
          console.log('Models.Presentation.Processed', e);
          dispatch('fetchPresentationJobs')
            .catch(() => {
            });
        })
        .listen('PresentationJobUpdated', e => {
          console.log('PresentationJobUpdated', e);
          dispatch('fetchPresentationJobs')
            .catch(() => {
            });
        })
        .listen('PresentationJobDeleted', e => {
          console.log('PresentationJobDeleted', e);
          dispatch('fetchPresentationJobs')
            .catch(() => {
            });
        });
    }
    console.log('initEcho completed', user.name);
  },
  updateActiveFolders({commit, dispatch}, activeFolders) {
    if (isInteger(activeFolders)) {
      dispatch('setActiveFolderID', activeFolders);
    } else if (isArray(activeFolders) && activeFolders.length) {
      dispatch('setActiveFolderID', activeFolders[0]);
    } else {
      dispatch('setActiveFolderID', homeFolder.id);
    }
  },
  setActiveFolderID({commit, dispatch, getters}, folderID) {
    if (isInteger(folderID)) {
      if (folderID === homeFolder.id) {
        commit('setFolder', homeFolder);
      } else {
        const folder = find(getters.folders, f => f.id === folderID);
        commit('setFolder', folder);
      }
    } else {
      commit('setFolder', homeFolder);
    }
    return Promise.resolve(true);
  },
  setErrorMessage({commit}, errorMessage) {
    commit('setErrorMessage', errorMessage);
  },
  refreshTokenPeriodically({dispatch}) { // MLD-4934
    const delayMinutes = 5; // minutes
    const delayMS = 1000 * 60 * delayMinutes; // milliseconds
    refreshID = window.setInterval(() => {
      dispatch('refreshToken');
    }, delayMS);
    dispatch('refreshToken');
  },
  refreshToken({commit}) { // MLD-4934
    return axios.put('/spark/token')
      .then(response => {
        if (response.data && response.data.csrf_token) {
          commit('setCsrfToken', response.data.csrf_token);
        }
        commit('setReloadRequired', false);
        return true;
      })
      .catch(err => {
        if (err.response && err.response.status >= 400) {
          commit('setReloadRequired', true);
          if (refreshID) {
            window.clearInterval(refreshID);
            refreshID = null;
          }
        }
      });
  },
  setSuccessMessage({commit}, successMessage) {
    commit('setSuccessMessage', successMessage);
  },
}

export default {
  namespaced: false,
  state,
  mutations,
  getters,
  actions,
}
